<template>
  <div class="document-list-item-meta">
    <FontAwesomeIcon
      aria-hidden="true"
      class="carrier-portal-document-list-item-file-icon text-2xl"
      :icon="icon"
    />
    <div class="document-list-item-meta-text">
      <div
        v-tooltip.right="documentTypeText"
        class="carrier-portal-document-list-item-meta-filename"
      >
        {{ documentTypeText }}
      </div>
      <div
        v-if="status === 'not-present'"
        class="carrier-portal-document-list-item-meta-missing"
      >
        {{ t('carrierPortal.documents.missing') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useTooltip } from '@rygen/rygen-ui/composables';
import { translateEnum } from '@rygen/rygen-ui/i18n';
import { CorsairDocumentType } from '@rygen/rygen-ui/model';

import { DocumentUploadStatus, SignedDocument } from '@/model';

const props = defineProps({
  doc: {
    type: Object as PropType<SignedDocument>,
    default: () => undefined,
  },
  type: {
    type: String as PropType<CorsairDocumentType>,
    default: () => CorsairDocumentType.BOL,
  },
  status: {
    type: String as PropType<DocumentUploadStatus>,
    default: 'not-present',
  },
});
const { doc, type, status } = toRefs(props);

const { t } = useI18n();
const vTooltip = useTooltip();

const icon = computed(() => {
  if (doc?.value) {
    return ['far', 'file-check'];
  } else if (status.value === 'placeholder') {
    return ['far', 'file-plus'];
  } else {
    return ['far', 'file-exclamation'];
  }
});

const documentTypeText = computed(() =>
  translateEnum(type.value, 'CorsairDocumentType'),
);
</script>

<style>
.document-list-item-meta {
  display: flex;
  align-items: center;
  gap: var(--sp-3);

  .document-list-item-meta-text {
    display: flex;
    flex-direction: column;
  }

  .carrier-portal-document-list-item-meta-filename,
  .carrier-portal-document-list-item-meta-missing {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.3;
  }
}
</style>
